<div *ngIf="isVisible" class="right-first-level-container flex flex-col h-full tk-panel-bg" [@openClose]>

  <div *ngIf="!isPasswordChangeVisible && !isAccountDataVisible" class="p-4 flex justify-between align-middle">
    <span class="font-semibold text-xl">{{'user-profile.header' | translate}}</span>
    <app-close-button class="self-center mt-1" (close)="onNavigateToMain()"></app-close-button>
  </div>

  <div *ngIf="isPasswordChangeVisible" class="p-4 flex align-middle bg-white">
    <app-arrow-left-button class="mr-2 mt-2" (close)="onNavigateToPasswordChange()"></app-arrow-left-button>
    <span class="font-semibold text-xl">{{'user-profile.password-change' | translate}}</span>
  </div>

  <div *ngIf="isAccountDataVisible" class="p-4 flex align-middle bg-white">
    <app-arrow-left-button class="mr-2 mt-2" (close)="isAccountDataVisible = false"></app-arrow-left-button>
    <span class="font-semibold text-xl">{{'Dane konta' | translate}}</span>
  </div>

  <div *ngIf="wasPasswordChanged" class="mt-4 py-4 px-4 tk-panel-bg" style="z-index: 700">
    <div class="bg-white flex flex-col rounded-md">

      <div class="mb-4 self-end tk-green-bg h-0.5" [ngStyle]="{'width.%': messageIntervalWidthPercent}"></div>

      <div class="flex align-middle mb-4">
        <span class="tk-i-pass-changed self-center ml-5 mr-3"></span>
        <span class="font-semibold text-xs">{{'user-profile.password-changed' | translate}}</span>
      </div>

    </div>
  </div>

  <app-profile-data 
    *ngIf="!isPasswordChangeVisible && !isAccountDataVisible"
    class="h-full"
    [isPasswordChanged]="wasPasswordChanged"
    (onPasswordChange)="onNavigateToPasswordChange()"
    (onRedirectToAccountData)="onRedirectToAccountData()"
  ></app-profile-data>

  <ng-container *ngIf="isPasswordChangeVisible">

    <!--    <div class="p-4 flex">-->
    <!--      <div class="mr-4 font-bold text-xl cursor-pointer" (click)="onNavigateToPasswordChange()"><</div>-->
    <!--      <span class="font-semibold text-xl">Edycja danych konta</span>-->
    <!--    </div>-->

    <app-change-password class="h-full" (passwordChanged)="onPasswordChanged($event)"></app-change-password>
  </ng-container>

  <app-account-data-form *ngIf="isAccountDataVisible" class="h-full"></app-account-data-form>

  <!-- <div *ngIf="!isPasswordChangeVisible" class=" flex w-full ">
    <button id="btn-logout"
            class="w-full mx-4 mb-4 justify-items-center tk-bg-nero tk-bg-nero-dark-hover text-white rounded-md py-2 hover:font-normal"
            (click)="onLogout()">
      {{'user-profile.logout' | translate}}
    </button>
  </div> -->

</div>
